export const faqList = [
  {
    question: '91爆料网的信息来源可靠吗？',
    answer: '我们拥有一支专业的爆料采集团队，信息来源于多方渠道交叉验证。对于每条爆料，我们都会进行严格的事实核查，确保发布的内容真实可靠。同时，我们也欢迎广大网友提供线索，共同维护信息的真实性。',
  },
  {
    question: '如何向91爆料网提供爆料线索？',
    answer: '您可以通过网站底部的"联系我们"表单提交爆料线索，也可以发送邮件到我们的官方邮箱。我们承诺对所有爆料人信息严格保密，保护您的隐私安全。',
  },
  {
    question: '91爆料网的内容更新频率是怎样的？',
    answer: '我们的编辑团队全天候监测全网热点，每天至少更新50条以上的新鲜爆料。重大事件发生后，我们会在30分钟内发布第一手消息，确保您不会错过任何精彩内容。',
  },
  {
    question: '91爆料网是否收费？',
    answer: '91爆料网对所有用户完全免费！我们不收取任何阅读费用，也无需注册会员。您只需要打开我们的网站，就能畅享所有精彩爆料内容。',
  },
  {
    question: '如果发现不实信息怎么办？',
    answer: '我们设有专门的核实与纠错机制。如果您发现任何不实信息，请立即通过"联系我们"渠道反馈，我们会在收到反馈后24小时内进行核实，如确认有误会立即更正并公开道歉。',
  },
  {
    question: '91爆料网有手机App吗？',
    answer: '目前我们正在紧锣密鼓地开发移动端App，预计将在下个季度上线。现在您可以通过手机浏览器访问我们的网站，我们已做了完善的移动端适配，体验同样出色。',
  },
];

export const testimonials = [
  {
    name: '小王',
    role: '忠实用户·3年',
    content: '自从发现了91爆料网，我每天的快乐源泉就有了！八卦内容新鲜热辣，更新速度超快，比微博还快一步！',
    rating: 5,
  },
  {
    name: '李大嘴',
    role: '资深吃瓜群众',
    content: '91爆料网是我见过最专业的吃瓜平台，信息准确度高，而且分类清晰，想看什么类型的八卦都能快速找到。',
    rating: 5,
  },
  {
    name: '张美丽',
    role: '自媒体人',
    content: '作为自媒体从业者，91爆料网是我每天必看的素材来源。热点追踪及时，爆料角度独特，给了我很多创作灵感。',
    rating: 5,
  },
];